import gql from 'graphql-tag';
import { graphql } from 'react-apollo';
import communityMetaDataFragment from '../../fragments/community/communityMetaData';

import communityInfoFragment from '../../fragments/community/communityInfo';

import communityChannelConnectionFragment from '../../fragments/community/communityChannelConnection';

import { getCommunityRoleMembersQuery } from 'shared/graphql/queries/community/getCommunityRoleMembers';
import { getcommunityMembersQuery } from 'shared/graphql/queries/community/getCommunityMembers';

export const removeCommunityMemberQuery = gql`
  mutation removeCommunityMember($input: RemoveCommunityMemberInput!) {
    removeCommunityMember(input: $input) {
      ...communityInfo
      ...communityMetaData
      ...communityChannelConnection
    }
  }
  ${communityInfoFragment}
  ${communityMetaDataFragment}
  ${communityChannelConnectionFragment}
`;

const removeCommunityMemberOptions = {
  options: {
    refetchQueries: ['getCurrentUserCommunityConnection'],
  },
  props: ({ mutate }) => ({
    removeCommunityMember: ({ input }) =>
      mutate({
        variables: {
          input,
        },
        refetchQueries: [
          {
            query: getCommunityRoleMembersQuery,
            variables: {
              id: input.communityId,
            },
          },
          {
            query: getcommunityMembersQuery,
            variables: {
              id: input.communityId,
            },
          },
        ],
      }),
  }),
};

export default graphql(
  removeCommunityMemberQuery,
  removeCommunityMemberOptions
);
